import { useEffect, useMemo, useState } from 'react';
import { CUSTOM_WIDGET_TYPES } from 'reporting-data/tsTypes/customWidgetTypes';
import { getCustomWidgetType } from 'reporting-data/report/reportGetters';
// @ts-expect-error Untyped dependency
import { resolveReport as resolveSalesQuota } from 'reporting-ui-components/components/customWidgets/SalesQuota/resolve';
// @ts-expect-error Untyped dependency
import resolvePushAnalysis from 'reporting-ui-components/components/customWidgets/DealPushAnalysis/resolve';
// @ts-expect-error Untyped dependency
import resolveWaterfall from 'reporting-ui-components/components/customWidgets/Waterfall/resolve';
// @ts-expect-error Untyped dependency
import resolveDealChangeHistory from 'reporting-ui-components/components/customWidgets/ChangeHistoryDealList/resolve';
// @ts-expect-error Untyped dependency
import { fillDateRangeToReport } from 'reporting-ui-components/components/customWidgets/lib/salesAnalytics/helpers';
import SalesCustomWidgetKPIContent, { hasPlatformResolverKpi } from './SalesCustomWidgetKPIContent';
import { jsx as _jsx } from "react/jsx-runtime";
const CUSTOM_WIDGET_RESOLVERS = {
  [CUSTOM_WIDGET_TYPES.CHANGE_HISTORY_DEAL_LIST]: resolveDealChangeHistory,
  [CUSTOM_WIDGET_TYPES.DEAL_PUSH_ANALYSIS]: resolvePushAnalysis,
  [CUSTOM_WIDGET_TYPES.SALES_QUOTA]: resolveSalesQuota,
  [CUSTOM_WIDGET_TYPES.WATERFALL]: resolveWaterfall
};
const SalesCustomWidgetKPIPreview = ({
  report,
  NoSummaryComponent
}) => {
  const [reportResolve, setReportResolve] = useState(null);
  const [hasError, setHasError] = useState(false);
  const preparedReport = useMemo(() => fillDateRangeToReport(report), [report]);
  const customWidgetType = getCustomWidgetType(report);
  const resolveReport = useMemo(() => customWidgetType && CUSTOM_WIDGET_RESOLVERS[customWidgetType], [customWidgetType]);
  useEffect(() => {
    if (resolveReport) {
      resolveReport(preparedReport).then(data => {
        setReportResolve({
          data
        });
      }).catch(() => {
        setHasError(true);
      });
    }
  }, [preparedReport, resolveReport]);
  if (!hasPlatformResolverKpi(report) && (hasError || !resolveReport)) {
    return /*#__PURE__*/_jsx(NoSummaryComponent, {});
  }
  return /*#__PURE__*/_jsx(SalesCustomWidgetKPIContent, {
    previewReport: preparedReport,
    reportResolve: reportResolve,
    isPreview: true
  });
};
export default SalesCustomWidgetKPIPreview;